const TRANSLATION_KEYS = {
  SOMETHING_WENT_WRONG: 'SOMETHING_WENT_WRONG',
  CONNECTION_LOST_TITLE: 'CONNECTION_LOST_TITLE',
  CONNECTION_LOST_TEXT: 'CONNECTION_LOST_TEXT',
  SESSION_TERMINATED_TITLE: 'SESSION_TERMINATED_TITLE',
  SESSION_TERMINATED_TEXT: 'SESSION_TERMINATED_TEXT',
  REFRESH: 'REFRESH',
  OK: 'OK',
  CLAIM_YOUR_FREE_SPINS: 'CLAIM_YOUR_FREE_SPINS',
  ENTER_PROMO_CODE: 'ENTER_PROMO_CODE',
  CLAIM: 'CLAIM',
  CONGRATULATIONS: 'CONGRATULATIONS',
  PROMO_SUCCESS_MESSAGE: 'PROMO_SUCCESS_MESSAGE',
  PRE_LOBBY_SUCCESS_MESSAGE: 'PRE_LOBBY_SUCCESS_MESSAGE',
  ENTER_PRE_LOBBY_CODE: 'ENTER_PRE_LOBBY_CODE',
  PLAY_NOW: 'PLAY_NOW',
  CLAIM_NOW: 'CLAIM_NOW',
  FREE_SPINS_SUCCESSFULLY_CLAIMED: 'FREE_SPINS_SUCCESSFULLY_CLAIMED',
  GO_TO_LOBBY: 'GO_TO_LOBBY',
  NO_DATA_TO_DISPLAY: 'NO_DATA_TO_DISPLAY',
  DEMO: 'DEMO',
  LAST_PLAYER_HAS_WON: 'LAST_PLAYER_HAS_WON',
  SEARCH: 'SEARCH',
  LOBBY: 'LOBBY',
  TOURNAMENT: 'TOURNAMENT',
  PROMO_CODE: 'PROMO_CODE',
  TAKE_YOUR_CASHBACK: 'TAKE_YOUR_CASHBACK',
  CLAIM_CASHBACK_DESC: 'CLAIM_CASHBACK_DESC',
  HOW_TO_ADD_BAHAMUT_ADDRESS: 'HOW_TO_ADD_BAHAMUT_ADDRESS',
  YOU_HAVE_WON: 'YOU_HAVE_WON',
  CASHBACK_INFO_FTN: 'CASHBACK_INFO_FTN',
  CASHBACK_INFO_REAL_MONEY: 'CASHBACK_INFO_REAL_MONEY',
  CASHBACK_INFO_FREEBET: 'CASHBACK_INFO_FREEBET',
  CASHBACK_CLAIMING_LIMIT_EXCEEDED: 'CASHBACK_CLAIMING_LIMIT_EXCEEDED',
  CASHBACK_ACCULATION_MIN_ODD: 'CASHBACK_ACCULATION_MIN_ODD',
  CASHBACK_DAILY: 'CASHBACK_DAILY',
  CASHBACK_WEEKLY: 'CASHBACK_WEEKLY',
  CASHBACK_MONTHLY: 'CASHBACK_MONTHLY',
  CLAIMED: 'CLAIMED',
  BAHAMUT_ADDRESS_PLACEHOLDER: 'BAHAMUT_ADDRESS_PLACEHOLDER',
  WRONG_WALLET_ADDRESS: 'WRONG_WALLET_ADDRESS',
  SEE_DETAILS: 'SEE_DETAILS',
  YOU_HAVE_WON_IN_A_TOURNAMENT: 'YOU_HAVE_WON_IN_A_TOURNAMENT',
  SCORE: 'SCORE',
  REAL_MODE: 'REAL_MODE',
  YOUR_RANK: 'YOUR_RANK',
  FREE_ROLL: 'FREE_ROLL',
  THIS_GAME_NOW_IS_ON_TOURNAMENT: 'THIS_GAME_NOW_IS_ON_TOURNAMENT',
  REBUY: 'REBUY',
  JOIN: 'JOIN',
  DAYS_TOURNAMENT: 'DAYS_TOURNAMENT',
  HRS_TOURNAMENT: 'HRS_TOURNAMENT',
  MINS_TOURNAMENT: 'MINS_TOURNAMENT',
  SECS_TOURNAMENT: 'SECS_TOURNAMENT',
  DONT_SHOW_THIS_AGAIN: 'DONT_SHOW_THIS_AGAIN',
  DAILY: 'DAILY',
  WEEKEND: 'WEEKEND',
  HOURLY: 'HOURLY',
  WEEKLY: 'WEEKLY',
  ENDS_IN: 'ENDS_IN',
  STARTS_IN: 'STARTS_IN',
  DONT_SHOW_AGAIN: 'DONT_SHOW_AGAIN',
  HOURS: 'HOURS',
  MINUTES: 'MINUTES',
  SECONDS: 'SECONDS',
  LARGEST_WINNER: 'LARGEST_WINNER',
  DD: 'DD',
  HH: 'HH',
  MM: 'MM',
  SS: 'SS',
  CASHBACK_REWARD_AMOUNT: 'CASHBACK_REWARD_AMOUNT',
  CASHBACK_GOAL_AMOUNT: 'CASHBACK_GOAL_AMOUNT',
  CASHBACK_CLAIMING_FREQUENCY: 'CASHBACK_CLAIMING_FREQUENCY',
  CASHBACK_CHARGE_METER_TITLE: 'CASHBACK_CHARGE_METER_TITLE',
  CASHBACK_REWARD_METER_INFO: 'CASHBACK_REWARD_METER_INFO',
  CASHBACK_ANNOUNCEMENT_FROM: 'CASHBACK_ANNOUNCEMENT_FROM',
  DEAR_PLAYER: 'DEAR_PLAYER',
  YOUR_GAME_IS_PAUSED: 'YOUR_GAME_IS_PAUSED',
  BOG: 'BOG',
  ARCADE: 'ARCADE',
  BET_ON_GAMES: 'BET_ON_GAMES',
  SPORT_FAN: 'SPORT_FAN',
  SLOT: 'SLOT',
  TABLE_GAMES: 'TABLE_GAMES',
  BETSHOP: 'BETSHOP',
  VIRTUAL_GAMES: 'VIRTUAL_GAMES',
  CRYPTO_GAMES: 'CRYPTO_GAMES',
  BONUS: 'BONUS',
  INSTANT: 'INSTANT',
  TRONIX: 'TRONIX',
  VIRTUAL_SPORTS: 'VIRTUAL_SPORTS',
  PREDICTOR: 'PREDICTOR',
  NUMBER_GAMES: 'NUMBER_GAMES',
  MIN: 'MIN',
  MAX: 'MAX',
  ALL_GAMES: 'ALL_GAMES',
  SELECT_GAMES: 'SELECT_GAMES',
  COMING_SOON: 'COMING_SOON',
  FREE_DROP_IS_LIVE: 'FREE_DROP_IS_LIVE',
  EVERY_BET_ADDS_ENERGY: 'EVERY_BET_ADDS_ENERGY',
  HIGHER_YOUR_LEVEL_BIGGER_PRIZE: 'HIGHER_YOUR_LEVEL_BIGGER_PRIZE',
  WIN_UP_TO: 'WIN_UP_TO',
  DAY: 'DAY',
  MONTH: 'MONTH',
  FREE_DROP: 'FREE_DROP',
  NEXT_DROP_IN: 'NEXT_DROP_IN',
  DROP_DATES: 'DROP_DATES',
  LEVEL: 'LEVEL',
  FREE_DROP_RULES: 'FREE_DROP_RULES',
  RICH_FREE_DROP_RULES_DESC: 'RICH_FREE_DROP_RULES_DESC',
  REWARD: 'REWARD',
  FREE_DROP_REWARD_DESC: 'FREE_DROP_REWARD_DESC',
  PREGRESS_BAR: 'PREGRESS_BAR',
  FREE_DROP_PREGRESS_BAR_DESC: 'FREE_DROP_PREGRESS_BAR_DESC',
  TIMER: 'TIMER',
  FREE_DROP_TIMER_DESC: 'FREE_DROP_TIMER_DESC',
  CASHBACK_ANNOUNCEMENT_POPUP_DAILY: 'CASHBACK_ANNOUNCEMENT_POPUP_DAILY',
  CASHBACK_ANNOUNCEMENT_POPUP_WEEKLY: 'CASHBACK_ANNOUNCEMENT_POPUP_WEEKLY',
  CASHBACK_ANNOUNCEMENT_POPUP_MONTHLY: 'CASHBACK_ANNOUNCEMENT_POPUP_MONTHLY',
  CASHBACK_ANNOUNCEMENT_POPUP_FREEBET: 'CASHBACK_ANNOUNCEMENT_POPUP_FREEBET',
  CASHBACK_ANNOUNCEMENT_POPUP_REAL_MONEY: 'CASHBACK_ANNOUNCEMENT_POPUP_REAL_MONEY',
  NEXT: 'NEXT',
  UPCOMING: 'UPCOMING',
  FINISHED: 'FINISHED',
  TURNOVER: 'TURNOVER',
  WIN: 'WIN',
  YOU_WON: 'YOU_WON',
  FREE_DROP_ACCULATION_MIN_ODD: 'FREE_DROP_ACCULATION_MIN_ODD',
  PRIZE_POOL: 'PRIZE_POOL',
  WINNERS: 'WINNERS',
  JACKPOT_DETAILS: 'JACKPOT_DETAILS',
  GAMES: 'GAMES',
  TOP_WINNER: 'TOP_WINNER',
  LAST_WINNER: 'LAST_WINNER',
  ID: 'ID',
  JACKPOT_RULES: 'JACKPOT_RULES',
  RICH_JACKPOT_RULES_DESCRIPTION: 'RICH_JACKPOT_RULES_DESCRIPTION',
  JACKPOT_WIN_CONGRATULATIONS: 'JACKPOT_WIN_CONGRATULATIONS',
  CLUB: 'CLUB',
  DIAMOND: 'DIAMOND',
  HEART: 'HEART',
  SPADE: 'SPADE',
  GOAL: 'GOAL',
  CLAIMING_FREQUENCY: 'CLAIMING_FREQUENCY',
  DATES: 'DATES',
  DURATION: 'DURATION',
  EXPIRE: 'EXPIRE',
  DAILY_AWARDS_TITLE: 'DAILY_AWARDS_TITLE',
  BOOSTED_JACKPOT: 'BOOSTED_JACKPOT',
  RULES_DESCRIPTION_2: 'RULES_DESCRIPTION_2',
  RULES: 'RULES',
  WINNERS_COUNT_LEFT: 'WINNERS_COUNT_LEFT',
  WINNING_COUNT: 'WINNING_COUNT',
  PG_WHEEL_MIN_BET_AMOUNT: 'PG_WHEEL_MIN_BET_AMOUNT',
  PG_WHEEL_WIN_COUNT_UP_TO: 'PG_WHEEL_WIN_COUNT_UP_TO',
  PG_WHEEL_ANOUNCEMENT_POPUP_TITLE: 'PG_WHEEL_ANOUNCEMENT_POPUP_TITLE',
  PRIZE_POOL_LEFT: 'PRIZE_POOL_LEFT',
  SPIN: 'SPIN',
  PG_WHEEL_RICH_RULES: 'PG_WHEEL_RICH_RULES',
  PG_WHEEL_RULES_BOTTOM: 'PG_WHEEL_RULES_BOTTOM',
  PLAYER_HAS_WON_JACKPOT: 'PLAYER_HAS_WON_JACKPOT',
  JACKPOT: 'JACKPOT',
  DETAILS: 'DETAILS',
  PG_WHEEL: 'PG_WHEEL',
  CLAIM_YOUR_FREE_SPIN_HERE: 'CLAIM_YOUR_FREE_SPIN_HERE',
  FREE_BET: 'FREE_BET',
  CONTINUE: 'CONTINUE',
  BUDGET_LEFT: 'BUDGET_LEFT',
  CASHBACK_INFO_DATES: 'CASHBACK_INFO_DATES',
  CASHBACK_INFO_REMAINING_BUDGET: 'CASHBACK_INFO_REMAINING_BUDGET',
  LVL: 'LVL',
  COMPLETED: 'COMPLETED',
  REWARDS: 'REWARDS',
  PROGRESS: 'PROGRESS',
  PRIZE: 'PRIZE',
  TIME_LEFT: 'TIME_LEFT',
  RESET_IN: 'RESET_IN',
  REWARDS_RICH_RULES: 'REWARDS_RICH_RULES',
  REWARDS_RICH_LEVEL: 'REWARDS_RICH_LEVEL',
  CASHBACK_ACCULATION_MIN_BET_AMOUNT: 'CASHBACK_ACCULATION_MIN_BET_AMOUNT',
  PASCAL_REWARDS: 'PASCAL_REWARDS',
  PLAY: 'PLAY',
  BET_ON_ELIGIBLE_GAMES: 'BET_ON_ELIGIBLE_GAMES',
  LEVEL_UP: 'LEVEL_UP',
  FILL_YOUR_PROGRESS_BAR: 'FILL_YOUR_PROGRESS_BAR',
  GET_PRIZES: 'GET_PRIZES',
  UNLOCK_CASH_AND_FREE_SPINS: 'UNLOCK_CASH_AND_FREE_SPINS',
  UNLOCK_YOUR: 'UNLOCK_YOUR',
  TOTAL_REWARDS_UP_TO: 'TOTAL_REWARDS_UP_TO',
  WIN_REWARDS: 'WIN_REWARDS',
  START_PASCAL_REWARDS: 'START_PASCAL_REWARDS',
  REWARDS_LEVEL_UP_NOTIFICATION: 'REWARDS_LEVEL_UP_NOTIFICATION',
  REWARDS_NOTIFICATION_90: 'REWARDS_NOTIFICATION_90',
  REWARDS_NOTIFICATION_50: 'REWARDS_NOTIFICATION_50',
  REWARDS_PRIZE_READY_NOTIFICATION: 'REWARDS_PRIZE_READY_NOTIFICATION',
  REWARDS_ENDING_NOTIFICATION: 'REWARDS_ENDING_NOTIFICATION',
  GAME_NOT_FOUND_TITLE: 'GAME_NOT_FOUND_TITLE',
  INVALID_CREDENTIALS_TITLE: 'INVALID_CREDENTIALS_TITLE',
  GAME_IS_OPEN_TITLE: 'GAME_IS_OPEN_TITLE',
  GAME_IS_OPEN_TEXT: 'GAME_IS_OPEN_TEXT',
  NOT_ENOUGH_MONEY_TITLE: 'NOT_ENOUGH_MONEY_TITLE',
  NOT_ENOUGH_MONEY_TEXT: 'NOT_ENOUGH_MONEY_TEXT',
  PLAYER_LIMIT_EXCEEDED_TITLE: 'PLAYER_LIMIT_EXCEEDED_TITLE',
  PLAYER_LIMIT_EXCEEDED_TEXT: 'PLAYER_LIMIT_EXCEEDED_TEXT',
  GENERAL_ERROR_TITLE: 'GENERAL_ERROR_TITLE',
  GENERAL_ERROR_TEXT: 'GENERAL_ERROR_TEXT',
  CLOSE: 'CLOSE',
  SEE_ALL: 'SEE_ALL',
  FREE_SPINS: 'FREE_SPINS',
  SPIN_AMOUNT: 'SPIN_AMOUNT',
  CAN_BE_USED_UNTIL: 'CAN_BE_USED_UNTIL',
  MIN_ODD: 'MIN_ODD',
  MAX_PAYOUT: 'MAX_PAYOUT',
  CHOOSE_A_GAME: 'CHOOSE_A_GAME',
  USE_NOW: 'USE_NOW',
  USE_LATER: 'USE_LATER',
  CONGRATULATIONS_YOUVE_WON_FREE_SPINS: 'CONGRATULATIONS_YOUVE_WON_FREE_SPINS',
  NEW_PROMO_CODE_AVAILABLE: 'NEW_PROMO_CODE_AVAILABLE',
  NEW_GAME_ADDED_TO_LOBBY: 'NEW_GAME_ADDED_TO_LOBBY',
  TOURNAMENT_ENDS_SOON: 'TOURNAMENT_ENDS_SOON',
  YOU_HAVE_RECEIVED: 'YOU_HAVE_RECEIVED',
  CHOOSE_A_REWARD: 'CHOOSE_A_REWARD',
  PROMOTIONS: 'PROMOTIONS',
  TODAY: 'TODAY',
  THIS_WEEK: 'THIS_WEEK',
  THIS_MONTH: 'THIS_MONTH',
  ALL_TIME: 'ALL_TIME',
  APPLY: 'APPLY',
  MULTIPLIER: 'MULTIPLIER',
  FILTER_BY_DATES: 'FILTER_BY_DATES',
  SORT_BY: 'SORT_BY',
  EMPTY_TOP_WINS_MY_CURRENT_GAME: 'EMPTY_TOP_WINS_MY_CURRENT_GAME',
  EMPTY_TOP_WINS_ALL_CURRENT_GAME: 'EMPTY_TOP_WINS_ALL_CURRENT_GAME',
  EMPTY_TOP_WINS_MY_ALL_GAMES: 'EMPTY_TOP_WINS_MY_ALL_GAMES',
  EMPTY_TOP_WINS_ALL_GAMES: 'EMPTY_TOP_WINS_ALL_GAMES',
  CURRENT_GAME: 'CURRENT_GAME',
  MY_TOP_WINS: 'MY_TOP_WINS',
  ALL_TOP_WINS: 'ALL_TOP_WINS',
  BET_ID: 'BET_ID',
  PASCAL_PROMOTIONS: 'PASCAL_PROMOTIONS',
  TOP_WINNERS: 'TOP_WINNERS',
  READY_TO_PLAY: 'READY_TO_PLAY',
  WATCH_REPLAY: 'WATCH_REPLAY',
  WATCH_AGAIN: 'WATCH_AGAIN',
  COPY_URL: 'COPY_URL',
  COPIED: 'COPIED',
  BIG_WIN_NOTIFICATION: 'BIG_WIN_NOTIFICATION',
  FREE_SPINS_EXPIRE_SOON: 'FREE_SPINS_EXPIRE_SOON',
  OOPS_SOMETHING_WENT_WRONG_LAUNCHING_GAME: 'OOPS_SOMETHING_WENT_WRONG_LAUNCHING_GAME',
  RELOADING: 'RELOADING',
  PLAY_DEMO: 'PLAY_DEMO',
  // send to pms ↓,
  MISSION_DETAILS: 'MISSION_DETAILS',
  QUALIFYING_CONDITIONS: 'QUALIFYING_CONDITIONS',
  REWARDS_ELIGIBLE_GAMES: 'REWARDS_ELIGIBLE_GAMES',
  ALL_ELIGIBLE_GAMES: 'ALL_ELIGIBLE_GAMES',
  REWARDS_MIN_BET: 'REWARDS_MIN_BET',
  REWARDS_MIN_ODD: 'REWARDS_MIN_ODD',
  REWARDS_FREEBET_REWARD: 'REWARDS_FREEBET_REWARD',
  REWARDS_CONDITION_TURNOVER_SHORT: 'REWARDS_CONDITION_TURNOVER_SHORT',
  REWARDS_CONDITION_TURNOVER_LONG: 'REWARDS_CONDITION_TURNOVER_LONG',
  REWARDS_CONDITION_BET_COUNT_SHORT: 'REWARDS_CONDITION_BET_COUNT_SHORT',
  REWARDS_CONDITION_BET_COUNT_LONG: 'REWARDS_CONDITION_BET_COUNT_LONG',
  REWARDS_CONDITION_TOTAL_WIN_AMOUNT_SHORT: 'REWARDS_CONDITION_TOTAL_WIN_AMOUNT_SHORT',
  REWARDS_CONDITION_TOTAL_WIN_AMOUNT_LONG: 'REWARDS_CONDITION_TOTAL_WIN_AMOUNT_LONG',
  REWARDS_CONDITION_WIN_COUNT_SHORT: 'REWARDS_CONDITION_WIN_COUNT_SHORT',
  REWARDS_CONDITION_WIN_COUNT_LONG: 'REWARDS_CONDITION_WIN_COUNT_LONG',
  REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_SHORT: 'REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_SHORT',
  REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_LONG: 'REWARDS_CONDITION_TOTAL_MULTIPLIER_COUNT_LONG',
  REWARDS_CONDITION_BUY_BONUS_COUNT_SHORT: 'REWARDS_CONDITION_BUY_BONUS_COUNT_SHORT',
  REWARDS_CONDITION_BUY_BONUS_COUNT_LONG: 'REWARDS_CONDITION_BUY_BONUS_COUNT_LONG',
  FREE_DROP_NEXT_FREE_SPIN_DROP_IN: 'FREE_DROP_NEXT_FREE_SPIN_DROP_IN',
  FREE_DROP_30_MINUTES_NOTIFICATION: 'FREE_DROP_30_MINUTES_NOTIFICATION',
  FREE_DROP_2_MINUTES_NOTIFICATION: 'FREE_DROP_2_MINUTES_NOTIFICATION',
  FREE_DROP_LEVEL_UNLOCKED_NOTIFICATION: 'FREE_DROP_LEVEL_UNLOCKED_NOTIFICATION',
  FREE_DROP_TAP_TO_OPEN: 'FREE_DROP_TAP_TO_OPEN',
  FREE_DROP_WIN_YOUR_REWARD: 'FREE_DROP_WIN_YOUR_REWARD',
  MAINTENANCE_NOTIFY_TEXT: 'MAINTENANCE_NOTIFY_TEXT',
  MAINTENANCE_NOTIFY_AFTER_ROUND_TEXT: 'MAINTENANCE_NOTIFY_AFTER_ROUND_TEXT',
  RANK: 'RANK',
  BUY_IN: 'BUY_IN',
};

export { TRANSLATION_KEYS as T };
